module.exports = __webpack_public_path__ + "img/jiaowu2.0fc03595.jpg";